import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-menuActivity",
  "use": "icon-menuActivity-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-menuActivity\">\n<path d=\"M9.75 15.75V17.625L7.5 16.125L5.25 17.625V15.75H4.875C4.17881 15.75 3.51113 15.4734 3.01884 14.9812C2.52656 14.4889 2.25 13.8212 2.25 13.125V3.75C2.25 3.15326 2.48705 2.58097 2.90901 2.15901C3.33097 1.73705 3.90326 1.5 4.5 1.5H15C15.1989 1.5 15.3897 1.57902 15.5303 1.71967C15.671 1.86032 15.75 2.05109 15.75 2.25V15C15.75 15.1989 15.671 15.3897 15.5303 15.5303C15.3897 15.671 15.1989 15.75 15 15.75H9.75ZM5.25 14.25V12.75H9.75V14.25H14.25V12H4.875C4.57663 12 4.29048 12.1185 4.0795 12.3295C3.86853 12.5405 3.75 12.8266 3.75 13.125C3.75 13.4234 3.86853 13.7095 4.0795 13.9205C4.29048 14.1315 4.57663 14.25 4.875 14.25H5.25ZM5.25 3.75V5.25H6.75V3.75H5.25ZM5.25 6V7.5H6.75V6H5.25ZM5.25 8.25V9.75H6.75V8.25H5.25Z\" fill=\"#334681\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/menuActivity.svg
// module id = fKbU
// module chunks = 111